import { render, staticRenderFns } from "./MyMediaAccreditationEvents.vue?vue&type=template&id=04b50c19&scoped=true"
import script from "./MyMediaAccreditationEvents.vue?vue&type=script&lang=js"
export * from "./MyMediaAccreditationEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b50c19",
  null
  
)

export default component.exports